import React from "react";
import {Dictionary} from "../components/Dictionary";

export class StatusPage extends React.Component<any, any> {
    private dictionary: Dictionary = new Dictionary();

    render() {
        return (
            <div className="error-page">
                <div>
                    <section>
                        <span>{this.props.code || 404}</span>
                        <p>
                            {this.dictionary.get[this.props.message || 'page-not-found']}
                        </p>
                    </section>
                </div>
            </div>
        );
    }
}
